import classNames from 'classnames';
import { Nullable } from 'src/types/nullable.type';
import React, { MouseEventHandler, ReactElement, VFC } from 'react';

interface StepEditorInitialSectionProps {
  title: string;
  subTitle: string;
  icon?: Nullable<ReactElement>;
  renderBadge?: () => ReactElement;
  className?: string;
  wrapperClassName?: string;
  subtitleClassName?: string;
  onClick: MouseEventHandler;
  hideBorderBottom?: boolean;
  disabled?: boolean;
}

export const StepEditorSection: VFC<StepEditorInitialSectionProps> = ({
  title,
  subTitle,
  className,
  hideBorderBottom,
  wrapperClassName,
  subtitleClassName,
  onClick,
  icon = null,
  renderBadge = () => null,
  disabled = false,
}) => {
  return (
    <button
      type='button'
      className={classNames(
        'relative has-hover flex text-bedrock-black cursor-pointer disabled:opacity-40',
        className,
        !hideBorderBottom &&
          "after:content-[''] after:h-px after:absolute after:bottom-0 after:w-full after:bg-bedrock-gray-medium"
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={classNames('flex w-full items-start justify-between overflow-hidden', wrapperClassName)}>
        <div className='flex items-center justify-start space-x-4 overflow-hidden'>
          {icon && <span className='p-2.5 bg-bedrock-light-gray rounded'>{icon}</span>}
          <div className='flex flex-col space-y-xs items-start overflow-hidden'>
            <span className='text-bedrock-p-strong'>{title}</span>
            <span className={classNames('w-full text-bedrock-p-small truncate text-left', subtitleClassName)}>
              {subTitle}
            </span>
          </div>
        </div>
        <div className='shrink-0'>{renderBadge()}</div>
      </div>
    </button>
  );
};
